import type { PivotColumnResponse } from "../../../../../../../../api/types/svTypes.ts";

export interface PivotColumnMetadata {
  filters: Record<string, string>;
  formattedValues?: string[];
  toolTip?: string;
}

export interface PivotColumnMetadataLookup {
  [pivotColumnId: string]: PivotColumnMetadata;
}

/**
 * Builds a flat lookup map from pivot column ID to its metadata by recursively traversing the column tree.
 * Each leaf measure column accumulates the dimension name/formatted values pairs along its ancestor path as filters,
 * which represent the dimension context (e.g. Account No = "AQ I", Posting Date= "2024") that the column belongs to.
 * Non-measure columns (e.g. "lines") and columns without an ID are skipped.
 */
export const buildPivotColumnMetadataLookup = (columns: PivotColumnResponse[]): PivotColumnMetadataLookup => {
  const lookup: PivotColumnMetadataLookup = {};

  const visit = (column: PivotColumnResponse, pathFilters: Array<[string, string]>): void => {
    const nextPathFilters = column.dimensionName
      ? [...pathFilters, [column.dimensionName, column.formattedValues?.join(", ") ?? ""] as [string, string]]
      : pathFilters;

    if (column.measureGuid !== undefined && column.id && column.id !== "lines") {
      lookup[column.id] = {
        filters: Object.fromEntries(nextPathFilters),
        formattedValues: column.formattedValues,
        toolTip: column.toolTip,
      };
    }

    column.columns.forEach((child) => visit(child, nextPathFilters));
  };

  columns.forEach((column) => visit(column, []));
  return lookup;
};
